






import Showcase from '@/views/client/Showcase/Showcase.vue'

export default {
  name: 'Home',
  components: {
    Showcase
  }
}
